import { ofType } from "redux-observable";
import { of } from "rxjs";
import { from } from "rxjs/internal/observable/from";
import { catchError, switchMap } from "rxjs/operators";
import { CommandCode, } from "../../../../utils/network/generated/protoTypes";
import { actionBaseInfoAddBuilding } from "../../../info/base/actionBaseInfo";
import { actionBuildingsCancelMove, actionBuildingsDeselect, TypeActionBuildings, } from "../actionBuildings";
export var epicBuildingsFinishMove = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionBuildings.FinishMove), switchMap(function (action) {
        var state = state$.value;
        return deps
            .netSend({
            id: CommandCode.MoveBuilding,
            props: {
                buildingId: action.building.proto.id,
                farmId: state.playerBase.base.baseId,
                flipped: action.building.proto.flipped,
                playerId: state.playerInfo.playerId,
                posX: action.building.proto.posX,
                posY: action.building.proto.posY,
            },
        })
            .pipe(switchMap(function () {
            return from([
                actionBuildingsDeselect(),
                actionBaseInfoAddBuilding(action.building.proto),
            ]);
        }), catchError(function () { return of(actionBuildingsCancelMove()); }));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/epics/epicBuildingsFinishMove.ts
// module id = 2054
// module chunks = 3